var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("a-modal", {
    attrs: {
      title: _vm.$t("产品详情"),
      visible: _vm.dialogVisible,
      footer: null,
      width: 1000
    },
    on: {
      cancel: () => {
        _vm.$emit("cancel");
      }
    }
  }, [_c("a-form-model", {
    attrs: {
      model: _vm.dataFrom,
      "label-col": {
        span: 4
      },
      "wrapper-col": {
        span: 18
      }
    }
  }, [_c("a-form-model-item", {
    attrs: {
      prop: "code",
      label: _vm.$t("产品代码")
    }
  }, [_c("a-input", {
    attrs: {
      disabled: true
    },
    model: {
      value: _vm.dataFrom.code,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "code", $$v);
      },
      expression: "dataFrom.code"
    }
  })], 1), _c("a-form-model-item", {
    attrs: {
      prop: "name",
      label: _vm.$t("产品名称")
    }
  }, [_c("a-input", {
    attrs: {
      disabled: true
    },
    model: {
      value: _vm.dataFrom.name,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "name", $$v);
      },
      expression: "dataFrom.name"
    }
  })], 1), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("保费")
    }
  }, [_c("a-input", {
    attrs: {
      disabled: true
    },
    model: {
      value: _vm.dataFrom.premium,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "premium", $$v);
      },
      expression: "dataFrom.premium"
    }
  })], 1), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("缴费期限")
    }
  }, [_c("a-input", {
    attrs: {
      disabled: true
    },
    model: {
      value: _vm.paymentDeadlineName,
      callback: function ($$v) {
        _vm.paymentDeadlineName = $$v;
      },
      expression: "paymentDeadlineName"
    }
  })], 1), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("保障期限")
    }
  }, [_c("a-input", {
    attrs: {
      disabled: true
    },
    model: {
      value: _vm.durationName,
      callback: function ($$v) {
        _vm.durationName = $$v;
      },
      expression: "durationName"
    }
  })], 1), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("保障方案")
    }
  }, _vm._l(_vm.dataFrom.rights, function (item, index) {
    return _c("div", {
      key: index,
      staticClass: "listBox"
    }, [_c("a-input", {
      staticClass: "input",
      attrs: {
        disabled: true
      },
      model: {
        value: item.name,
        callback: function ($$v) {
          _vm.$set(item, "name", $$v);
        },
        expression: "item.name"
      }
    }), _c("a-input", {
      staticClass: "input",
      attrs: {
        disabled: true
      },
      model: {
        value: item.value,
        callback: function ($$v) {
          _vm.$set(item, "value", $$v);
        },
        expression: "item.value"
      }
    }), _c("a-input", {
      attrs: {
        disabled: true
      },
      model: {
        value: item.info,
        callback: function ($$v) {
          _vm.$set(item, "info", $$v);
        },
        expression: "item.info"
      }
    })], 1);
  }), 0)], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };